import React from "react";
/**
 * This component is used to display the required
 * terms of use statement which can be found in a
 * link in the about tab.
 */
class TermsOfUse extends React.Component {
  render() {
    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src="https://appgenesisllc.com/termsofuse/"
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="Terms of Use"
        />
      </div>
    );
  }
}

export default TermsOfUse;
